import React, { useState, useEffect } from 'react';

import PropTypes from 'prop-types';
import { Typography } from '@telus-uds/components-web';

import ServiceForm from './serviceForm';
import ServiceList from './serviceList';

import { getPathVariables } from '../../misc';
import {
  getContentfulData,
  contentfulFormConfig,
  getData
} from '../../contentful';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';

const ServiceBusinessConnect = ({
  businessConnectServices,
  setBusinessConnectServices,
  setIsFormTouched
}) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    callCentre: { labelBusinessConnectServices }
  } = localizedStrings;

  const [servicesList, setServicesList] = useState([]);
  const [editService, setEditService] = useState();
  const locale = getPathVariables(window.location.pathname)[0];
  const config = {
    ...contentfulFormConfig,
    content_type: 'businessConnectServices',
    locale
  };

  useEffect(() => {
    getContentfulData(config).then(res => {
      const list = getData(res).serviceList.map(service => {
        return service.fields;
      });
      setServicesList(list);
    });
  }, []);

  return (
    <>
      <div style={{ margin: '1rem 0' }}>
        <Typography heading="h2" variant={{ size: 'h2' }} block>
          {labelBusinessConnectServices}
        </Typography>
      </div>
      <ServiceForm
        businessConnectServices={businessConnectServices}
        setBusinessConnectServices={setBusinessConnectServices}
        servicesList={servicesList}
        editService={editService}
        setEditService={setEditService}
        setIsFormTouched={setIsFormTouched}
      />
      {((!editService && businessConnectServices.length > 0) ||
        (editService && businessConnectServices.length > 1)) && (
        <ServiceList
          businessConnectServices={businessConnectServices}
          setBusinessConnectServices={setBusinessConnectServices}
          setEditService={setEditService}
          setIsFormTouched={setIsFormTouched}
          editService={editService}
        />
      )}
    </>
  );
};

ServiceBusinessConnect.propTypes = {
  businessConnectServices: PropTypes.arrayOf(PropTypes.any).isRequired,
  setBusinessConnectServices: PropTypes.func.isRequired,
  setIsFormTouched: PropTypes.func.isRequired
};

export default ServiceBusinessConnect;
